import { PAGE_PATHS } from '../../../types';

export type SoarApp = 'threats' | 'identities';

/**
 * Maps the host app to the base PAGE_PATHS segment used by getPathName.
 *
 * Usage with getPathName from useAvContext:
 *   getPathName(SOAR_BASE_PAGE_PATH[soarApp], '/playbooks')        → playbooks list
 *   getPathName(SOAR_BASE_PAGE_PATH[soarApp], `/playbooks/${id}`)  → playbook details
 *   getPathName(SOAR_BASE_PAGE_PATH[soarApp], '/automation-rules')  → automation rules list
 */
export const SOAR_BASE_PAGE_PATH: Record<SoarApp, string> = {
  threats: PAGE_PATHS.SOC_AUTOMATIONS,
  identities: PAGE_PATHS.IDENTITY_AUTOMATIONS,
};

/**
 * Returns true when the given entity type is within the provided scope.
 * An empty / undefined scope means "no scoping" (all entities allowed).
 */
export const matchesEntityScope = (entityType?: string, entityScope?: string[]): boolean => {
  if (!entityScope || entityScope.length === 0) return true;
  if (!entityType) return false;
  const normalized = entityType.toUpperCase().replace(/\s+/g, '_');
  return entityScope.includes(normalized);
};
